module.exports = __webpack_public_path__ + "img/imali_logo_big.db41624b.png";